import React from 'react'
import PaymentInformation from '../PaymentTypeSelection'
import { BuilderContent } from '@builder.io/react'
import { PagePropsAbstract } from 'components/pageNavigator'

function PaymentPage({ paymentAuthorizationNoticeContent, ...pageProps } : { paymentAuthorizationNoticeContent: BuilderContent } & PagePropsAbstract ) { // patientId is a required prop of type string
  return (
    <div className="mx-auto max-w-[700px] relative">
      <PaymentInformation paymentAuthorizationNoticeContent={paymentAuthorizationNoticeContent} {...pageProps} />
    </div>
  )
}

export default PaymentPage